import React, { useState } from 'react';
import { Box, Button, Dialog, DialogContent, IconButton, useMediaQuery } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { getWhatsApp } from '../../functions/getEmail';

const WhatsAppChat: React.FC = () => {
  const [open, setOpen] = useState(false);

  const number = `55${getWhatsApp()}`;
  
  const isMobile = useMediaQuery("(max-width:768px)");
  const handleClick = () => {
    const whatsappLink = `https://wa.me/${number}`

    // Abre o link em uma nova aba
    window.open(whatsappLink, '_blank');
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box position="sticky" bottom={0} left={0} display="flex" justifyContent={"flex-end"}>
      <IconButton
        color="warning"
        onClick={handleClick}
        aria-label="Open WhatsApp Chat"
      >
        <WhatsAppIcon sx={{ fontSize: isMobile ? "2em" : "4em"}}/>
      </IconButton>

      {/* Modal para Desktop */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogContent style={{ padding: 0 }}>
          <iframe
            src={`https://web.whatsapp.com/send?phone=${number}`}
            width="100%"
            height="400px"
            style={{ border: 'none' }}
            title="WhatsApp Chat"
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default WhatsAppChat;
